import * as React from 'react';

export default class DatetimeRenderer extends React.Component<any> {
    render() {
        let {value} = this.props;
        if (value < Date.now() / 1000) {
            value *= 1000;
        }
        return <div> {new Date(value).toLocaleString()} </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/DatetimeRenderer.tsx